import EmojiFoodBeverageIcon from '@mui/icons-material/EmojiFoodBeverage';
import { Dispatch, SetStateAction } from "react";
import { ToolsPanelToggleButton } from "../controls/ToolsPanelToggleButton";

type Props = {
    isActivated: boolean;
    setIsActivated: Dispatch<SetStateAction<boolean>>;
};

export function IncludeFeesInBalance({ isActivated, setIsActivated }: Props) {
    return (
        <ToolsPanelToggleButton
            isActivated={isActivated}
            setIsActivated={setIsActivated}
            tooltipTextWhenActivated="Include fees in the balance calculation"
            tooltipTextWhenDeactivated="Include fees in the balance calculation"
        >
            <EmojiFoodBeverageIcon sx={{ height: '18px', width: '18px' }} />
        </ToolsPanelToggleButton>
    );
}
